import { Filters } from "./transactions";

export const multi = [
    Filters.methodTag,
    Filters.currency
];
